import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src="./construction.png" className="App-logo" alt="construction" />
        <p>
          We are maintaining the website, please try again later ...
        </p>
      </header>
    </div>
  );
}

export default App;
